import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { useAllFilterBaseContext } from "../../../../../Context/AllFilterBaseContext";

export default function CountryOption({ values, title='Country' }) {
  const [allSkills, setAllSkills] = useState([]);
  const [selectSkills, setSelectSkills] = useState(null);
  const { state, setCountryies } = useAllFilterBaseContext();
  const { countries } = state;

  useEffect(() => {
    setAllSkills(values);
  }, [values]);

  const handleLanguageChange = (selectedOption) => {
    const newLanguage = {
      id: selectedOption.value,
      title: selectedOption.label,
    };
    const updatedSkills = [...countries, newLanguage];
    setCountryies(updatedSkills);
  };

  const handleDeleteLanguage = (id) => {
    const updatedLanguages = countries.filter(
      (language) => language.id !== id,
    );
    setCountryies(updatedLanguages);
  };
  
  return (
    <div>
      <ReactSelect
        options={
          Array.isArray(allSkills) &&
          allSkills
            .filter((lang) => {
              return (
                Array.isArray(countries) &&
                !countries.some(
                  (selectedLang) => selectedLang.id === lang.id,
                )
              );
            })
            .map((lang) => ({ value: lang.id, label: lang.title }))
        }
       placeholder={`Search ${title}`}
        isClearable={true}
        value={selectSkills}
        onChange={(options) => {
          if (options) {
            handleLanguageChange(options);
          }
        }}
      />

      <div className="add-skills">
        {Array.isArray(countries) &&
          countries.map((skills, index) => (
            <div key={index}>
              <p onClick={() => handleDeleteLanguage(skills.id)}>
                {skills.title} <span>x</span>
              </p>
            </div>
          ))}
      </div>
    </div>
  );
}
